import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, CheckCircle2, Sparkles } from 'lucide-react';
export const ProblemSolution = () => {
  return <section className="w-full py-24 px-6 bg-cream" data-id="element-182">
      <div className="max-w-5xl mx-auto" data-id="element-183">
        <div className="text-center mb-16" data-id="element-184">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-dark mb-4" data-id="element-185">
            Por qué los métodos tradicionales fallan
          </h2>
          <p className="font-body text-xl text-dark/70" data-id="element-186">
            Why traditional methods fail
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-187">
          {/* The Problem */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 grayscale-[0.3]" data-id="element-188">
            <div className="flex items-center space-x-4 mb-6" data-id="element-189">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-190">
                <AlertCircle className="w-6 h-6 text-gray-500" data-id="element-191" />
              </div>
              <h3 className="font-display text-2xl font-bold text-gray-800" data-id="element-192">
                El Momento del Caos
              </h3>
            </div>

            <div className="space-y-4 font-body text-gray-600" data-id="element-193">
              <p data-id="element-194">
                Imagina esto: Son las 5:30 PM. Estás agotada. Tu hijo quiere un
                dulce antes de la cena, tú dices que no, y el mundo se acaba.
                Los gritos llenan la cocina.
              </p>
              <p data-id="element-195">
                Intentas razonar: <em data-id="element-196">"Give me a second, please"</em>, luego
                intentas en español: <em data-id="element-197">"¡Cálmate, por favor!"</em>. Nada
                funciona. Te sientes juzgada, cansada y un poco fracasada.
              </p>
              <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-198">
                <h4 className="font-bold text-gray-800 mb-2" data-id="element-199">
                  La Promesa Rota
                </h4>
                <p data-id="element-200">
                  El "Time-out" hace que el niño se sienta solo en su emoción, y
                  la tablet solo anestesia el sentimiento sin enseñarle a
                  manejarlo. Mañana el berrinche regresa con más fuerza.
                </p>
              </div>
            </div>
          </motion.div>

          {/* The Solution */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 shadow-soft border-2 border-calm/20 relative overflow-hidden" data-id="element-201">
            <div className="absolute top-0 right-0 w-32 h-32 bg-calm/10 rounded-bl-full -z-10" data-id="element-202"></div>

            <div className="flex items-center space-x-4 mb-6" data-id="element-203">
              <div className="w-12 h-12 rounded-full bg-calm/20 flex items-center justify-center" data-id="element-204">
                <Sparkles className="w-6 h-6 text-calm" data-id="element-205" />
              </div>
              <h3 className="font-display text-2xl font-bold text-dark" data-id="element-206">
                Qué es este libro
              </h3>
            </div>

            <div className="space-y-4 font-body text-dark/80" data-id="element-207">
              <p className="font-bold text-lg text-dark" data-id="element-208">
                Una herramienta de descarga emocional.
              </p>
              <p data-id="element-209">
                No solo entretenemos al niño; le damos un lenguaje visual y
                verbal para que pueda sacar el sentimiento de su cuerpo y
                ponerlo en el papel.
              </p>
              <p data-id="element-210">
                Los libros de psicología infantil suelen ser demasiado complejos
                y los libros de colorear comunes son solo dibujos vacíos que no
                ofrecen ninguna herramienta real.
              </p>
              <div className="pt-4 mt-4 border-t border-calm/20 flex items-start space-x-3" data-id="element-211">
                <CheckCircle2 className="w-6 h-6 text-calm flex-shrink-0 mt-0.5" data-id="element-212" />
                <p className="font-medium" data-id="element-213">
                  Fortalece su identidad bilingüe mientras aprende a regular sus
                  emociones de forma saludable.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};